import decorator from './decorator';
import * as _actions from './actions';
export { _actions as actions };
export { fetchTranslations } from './actions';
import _reducer from './reducer';
export { _reducer as reducer };
export { InitialState } from './reducer';
import _Provider from './Provider';
export { _Provider as Provider };
export * from './tasks';
export default decorator;